export default {
    horimetroKMs: [],
    horimetroKM: {}
}